import {
  CloseButton,
  ListContext,
  ListContextValue,
  Stack,
  Typography,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { SubmitButton } from "components";
import { Staff } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { staffPageRoute } from "../StaffPage/StaffPage";

export const StaffPageHeader = (props: {
  handle: string;
  staff: Staff;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);

  const save = (staff: Staff) => {
    props.setValidationErrors({});

    ApiService.staff
      .saveCreate(staff)
      .then((response) => {
        const id = response;
        navigate(`../${staffPageRoute.getPath({ id: id, crudMode: "view" })}`);
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.response);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />
        <SubmitButton
          onClick={() => save(props.staff)}
          disabled={props.staff.id > 0 && !props.unsavedChanges}
        />
      </Stack>
    </Stack>
  );
};
